import { render, staticRenderFns } from "./ModalContentRecipient.vue?vue&type=template&id=0985adea"
import script from "./ModalContentRecipient.vue?vue&type=script&lang=js"
export * from "./ModalContentRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports